/**
 * Partners / sponsors for ETH México 2026 only.
 * Edit this file to update the /ETHMX2026 page.
 *
 * ETHMX2025 keeps its own lists in:
 * - src/components/Sponsors/Sponsors.js
 * - src/components/StrategicPartners/StrategicPartners.js
 * - src/components/MediaPartners/MediaPartners.js
 * - src/components/ComPartners/ComPartners.js
 *
 * Each entry: { name, image, width, link }
 * - image: filename under public/images/
 * - link: optional URL (empty string = no link)
 */

export const sponsors = [
  {
    name: "Bitso Business",
    image: "bitso-business-black.svg",
    width: "300px", 
    link: "https://x.com/Bitso", 
  },
  {
    name: "Super Rare",
    image: "Rare-xyz-logo.png",
    width: "300px", 
    link: "https://x.com/rare_protocol", 
  },
  {
    name: "Arbitrum",
    image: "Arbitrum_Logo_FullColorNavy.svg",
    width: "400px", 
    link: "https://x.com/arbitrum_esp", 
  },
  {
    name: "Base",
    image: "Base_lockup_2color.svg",
    width: "180px", 
    link: "https://x.com/ethereum_mexico/status/1973473598380843133", 
  },
  {
    name: "Etherfuse",
    image: "Etherfuse_Full-logo_black.png",
    width: "250px", 
    link: "https://x.com/ethereum_mexico/status/1980281196786393248", 
  },
  {
    name: "geodework",
    image: "geodework.png",
    width: "250px", 
    link: "https://x.com/geodelabs", 
  },
];

export const strategicPartners = [
  {
    name: "BuidlGuidl",
    image: "buidl.png",
    width: "180px", 
    link: "https://x.com/buidlguidl", 
  },
  {
    name: "México Tech Week",
    image: "MTW26.png",
    width: "220px", 
    link: "https://x.com/MexicoTechWeek", 
  },
  {
    name: "Frutero Club",
    image: "FruteroClub.png",
    width: "240px", 
    link: "https://x.com/fruteroclub", 
  },
  {
    name: "Mobil3",
    image: "Mobil326.png",
    width: "180px", 
    link: "https://x.com/mobil3_xyz", 
  }

];

export const mediaPartners = [
  {
    name: "Cryptoconexión",
    image: "cryptoconexion.png",
    width: "160px", 
    link: "https://x.com/cryptoconexion", 
  },
  {
    name: "Fundamento",
    image: "Fundamento-square.png",
    width: "160px", 
    link: "https://x.com/FundamentoMedia", 
  },
  {
    name: "Indasocial",
    image: "indasocial-logo.png",
    width: "160px", 
    link: "https://x.com/indasocial_mx", 
  },
  {
    name: "DIGITALIZADOS",
    image: "digitalizados-logo.png",
    width: "160px", 
    link: "https://x.com/digitalizadosco", 
  },

];

export const communityPartners = [
  {
    name: "Dev3Pack",
    image: "dev3pack-logo.png",
    width: "150px", 
    link: "https://x.com/dev3pack", 
  },
  {
    name: "H.E.R. DAO México",
    image: "herdaoMX-square.png",
    width: "150px", 
    link: "https://x.com/HerDaoMexico", 
  },
  {
    name: "Blocka",
    image: "blocka-square.png",
    width: "150px", 
    link: "https://x.com/lablockatoon", 
  },
  {
    name: "Nerdconf",
    image: "nerdconf-logo.png",
    width: "150px", 
    link: "https://x.com/nerdconf_ar", 
  },
  {
    name: "Crecimiento",
    image: "crecimiento.png",
    width: "150px", 
    link: "https://x.com/crecimientoar", 
  },
  {
    name: "Eth Napul",
    image: "Napul_ETH.png",
    width: "150px", 
    link: "https://x.com/NapulETH", 
  },
  {
    name: "Eth Chiangmai",
    image: "ethCh.png",
    width: "150px", 
    link: "https://x.com/ETHChiangmai", 
  },
  {
    name: "Eth Cluj",
    image: "ethCluj.png",
    width: "150px", 
    link: "https://x.com/ETHCluj", 
  },
  {
    name: "Cripto Unam",
    image: "cripto_unam.png",
    width: "150px", 
    link: "https://x.com/Cripto_UNAM", 
  },
  {
    name: "Ledger Leaders",
    image: "LL-week-logo.png",
    width: "150px", 
    link: "https://x.com/ForoBlockchain", 
  },
  {
    name: "Ethereum Tegucigalpa",
    image: "Eth_tegu-square.png",
    width: "150px", 
    link: "https://linktr.ee/ethereumtgu", 
  },
  {
    name: "UNLOCK Universe",
    image: "unlock-square.png",
    width: "150px", 
    link: "https://linktr.ee/UnlockSummit", 
  },
  {
    name: "Ethereum Bolivia",
    image: "eth-bolivia.png",
    width: "150px", 
    link: "https://x.com/EthereumBo", 
  },
  {
    name: "Criptec",
    image: "criptec-square.png",
    width: "150px", 
    link: "https://x.com/criptecmxllc", 
  },
  {
    name: "BandaWeb3",
    image: "bandaweb3-square.png",
    width: "150px", 
    link: "https://x.com/BandaWeb3", 
  },
  {
    name: "Ethereum Monterrey",
    image: "eth-mty-square.png",
    width: "150px", 
    link: "https://x.com/eth_mty", 
  },
  {
    name: "Chihuahua Tech Week",
    image: "ctw-square.png",
    width: "150px", 
    link: "https://x.com/ChihTechWeek", 
  },
  {
    name: "Paisano Dao",
    image: "paisano.png",
    width: "150px", 
    link: "https://x.com/paisanodao", 
  },
  {
    name: "BAF",
    image: "baf-square.png",
    width: "150px", 
    link: "https://x.com/TheBAFNetwork", 
  },
  {
    name: "Mxweb3",
    image: "mxweb3-square.png",
    width: "150px", 
    link: "https://x.com/mxweb3", 
  },
  {
    name: "Espacio Cripto",
    image: "espacio-cripto-square.png",
    width: "150px", 
    link: "https://x.com/EspacioCripto", 
  },
  {
    name: "Cripto Baja",
    image: "cripto_baja.png",
    width: "150px", 
    link: "https://x.com/CriptoBaja", 
  },
  {
    name: "The Holder",
    image: "ElHolder-square.png",
    width: "150px", 
    link: "https://x.com/elholder__", 
  },
  {
    name: "Es Blockchain",
    image: "EsBlockchainl-1-.png",
    width: "150px", 
    link: "https://x.com/3sBlockchain ", 
  },
  {
    name: "Marketers Web3",
    image: "marketersWeb3.png",
    width: "150px", 
    link: "https://x.com/marketersweb3", 
  },
  {
    name: "Eth Veracruz",
    image: "ETHEREUM-VERACRUZ.png",
    width: "150px", 
    link: "https://x.com/eth_veracruz", 
  },
  {
    name: "Cripto Plebada",
    image: "cripto_plebada.png",
    width: "150px", 
    link: "https://x.com/criptoplebada", 
  },
  {
    name: "Modular Crypto",
    image: "modularcripto.png",
    width: "150px", 
    link: "https://x.com/ModularCrypto", 
  },
  {
    name: "L-Phant",
    image: "l-phant.png",
    width: "150px", 
    link: "https://www.instagram.com/lphant.io", 
  },
  {
    name: "Zk Monk",
    image: "zk-monk.png",
    width: "150px", 
    link: "https://x.com/zk_monk", 
  },
  {
    name: "Kether Labs",
    image: "ketherlabs.png",
    width: "150px", 
    link: "https://x.com/ketherlabs", 
  },
  {
    name: "Opportuni",
    image: "Opportuni_Logo.png",
    width: "150px", 
    link: "https://www.instagram.com/opportuni__mx/", 
  },
  {
    name: "Innova UTCH",
    image: "innova-utch.png",
    width: "150px", 
    link: "https://www.instagram.com/innova_techcuu/", 
  },
  {
    name: "Bitcoin Cuernavaca",
    image: "bitcoin-cuerna.png",
    width: "150px", 
    link: "https://x.com/BTCCuernavaca", 
  },
  {
    name: "Merge CUU",
    image: "merge_cuu.png",
    width: "150px", 
    link: "https://x.com/merge_cuu", 
  },
  {
    name: "DeFi México",
    image: "defi_mexico.png",
    width: "150px", 
    link: "https://x.com/Defi_mex", 
  },
  {
    name: "Heka",
    image: "heka.png",
    width: "150px", 
    link: "https://x.com/HekaTechGirl", 
  },
  {
    name: "",
    image: "Rectangle 71.png",
    width: "150px", 
    link: "https://x.com/ttu_waa", 
  },
  {
    name: "ETH Ecuador",
    image: "ETH Ecuador.png",
    width: "150px", 
    link: "https://x.com/ETH_ECU", 
  },
  {
    name: "D Swap",
    image: "d-swap.png",
    width: "150px", 
    link: "https://x.com/DSwapOficial", 
  },
  {
    name: "bythelabxyz",
    image: "thelabs.png",
    width: "150px", 
    link: "https://x.com/bythelabxyz", 
  },


];

